import { Entity, NetworkArray, NetworkPaginationSlice } from 'typed/api/entities';
import { IReducer } from '.';
import { Action, ActionType } from 'typed/actions';

export { Entity, NetworkPaginationSlice, NetworkArray };

export type IEntitySet<E extends Entity> = E[] | NetworkArray<E> | NetworkPaginationSlice<E>;
export type IEntityReducerState<E extends Entity> = E | IEntitySet<E>;

export const isEntity = <E extends Entity>(s: IEntityReducerState<E>): s is E => s && 'EntityType' in s;
export const isSimpleArray = <E extends Entity>(s: IEntityReducerState<E>): s is E[] => s && Array.isArray(s);
export const isNetworkArray = <E extends Entity>(s: IEntityReducerState<E>): s is NetworkArray<E> => s && !Array.isArray(s) && 'Data' in s && Array.isArray(s.Data);
export const isPaginationSlice = <E extends Entity>(s: IEntityReducerState<E>): s is NetworkPaginationSlice<E> => s && Object.hasOwnProperty.call(s, 'Count') && Object.hasOwnProperty.call(s, 'TotalCount');

export interface IEntityReducerCreator {
    <E extends Entity, S extends NetworkPaginationSlice<E>, T extends ActionType>(def: S, type: T): IReducer<S, Action<T>>;
    <E extends Entity, S extends NetworkArray<E>, T extends ActionType>(def: S, type: T): IReducer<S, Action<T>>;
    <E extends Entity, S extends E[], T extends ActionType>(def: S, type: T): IReducer<S, Action<T>>;
    <E extends Entity, T extends ActionType>(def: E, type: T): IReducer<E, Action<T>>;
}

export { default as entityLoadAllReducer } from './entityLoadAllReducer';
export { default as entityLoadManyReducer } from './entityLoadManyReducer';
export { default as entityLoadReducer } from './entityLoadReducer';
export { default as entityAddAllReducer } from './entityAddAllReducer';
export { default as entityAddReducer } from './entityAddReducer';
export { default as entityEditAllReducer } from './entityEditAllReducer';
export { default as entityEditReducer } from './entityEditReducer';
export { default as entityDeleteAllReducer } from './entityDeleteAllReducer';
export { default as entityDeleteReducer } from './entityDeleteReducer';
export { default as entityVoidAllReducer } from './entityVoidAllReducer';
export { default as entityVoidReducer } from './entityVoidReducer';
export { default as sortedEntitiesReducer } from './sortedEntitiesReducer';
export { default as sortableEntitiesReducer } from './sortableEntitiesReducer';
export { default as nestableEntitiesReducer } from './nestableEntitiesReducer';
export { default as synchronizableEnumReducer } from './synchronizableEnumReducer';
export { default as inexpirableReducers } from './inexpirableReducers';
